<div id="shop_filters_content">
    <app-shop-filter title="{{'SHOP.FILTER_ALL_PRODUCTS' | translate}}" [items]="this.products" (onChangeFilter)="this.onChangeFilterProducts($event)"/>
    <app-shop-filter title="{{'SHOP.FILTER_ALL_LEVELS' | translate}}" [items]="this.levels" [multiple]="false" (onChangeFilter)="this.onChangeFilterLevels($event)"/>
    <app-shop-filter title="{{'SHOP.FILTER_ALL_COSTS' | translate}}" [items]="this.costsInPoints" (onChangeFilter)="this.onChangeFilterCostsInPoints($event)"/>
</div>
